export const state = () => ({
    shippingType: null,
    shippingAddress: null,
    invoiceAddress: null,
    checkoutCarrier: null,
    checkoutRelayPoint: null,
    paymentMethods: [],
    sameAsDelivery: true,
    guestInfo: {
        firstname: '',
        lastname: '',
        email: '',
    },
    refreshPaymentMethods: true,
    checkoutError: null,
    carrierLoading: false,
    submittingPayment: false,
    isExpressSyncing: false,
    isExpressActive: false,
    stripeClientSecret: null,
});

export const mutations = {
    setShippingType(state, { data }) {
        state.shippingType = data;
    },
    setShippingAddress(state, { data }) {
        state.shippingAddress = data;
    },
    setInvoiceAddress(state, { data }) {
        state.invoiceAddress = data;
    },
    setCheckoutCarrier(state, { data }) {
        state.checkoutCarrier = data;
    },
    setCheckoutRelayPoint(state, { data }) {
        state.checkoutRelayPoint = data;
    },
    setPaymentMethods(state, { data }) {
        state.paymentMethods = data;
    },
    setSameAsDelivery(state, { data }) {
        state.sameAsDelivery = data;
    },
    setGuestInfo(state, { data }) {
        state.guestInfo = data;
    },
    setRefreshPaymentMethods(state, data) {
        state.refreshPaymentMethods = data;
    },
    setCheckoutError(state, { data }) {
        state.checkoutError = data;
    },
    setCarrierLoading(state, data) {
        state.carrierLoading = data;
    },
    setSubmittingPayment(state, data) {
        state.submittingPayment = data;
    },
    setIsExpressSyncing(state, data) {
        state.isExpressSyncing = data;
    },
    setStripeClientSecret(state, data) {
        state.stripeClientSecret = data;
    },
    setIsExpressActive(state, data) {
        state.isExpressActive = data;
    },
};
